<template>
  <BreadCrumb v-if="showgrid" page="Beranda > Pendaftaran > Data Tes Kognitif > Data Hasil Tes Kognitif"></BreadCrumb>
  <div class="container content-area" v-if="showgrid">
    <div class="row">
      <div class="col-md-12">
        <h3 class="judul-seksi-sga">Data Hasil Tes Kognitif</h3></div>
    </div>
    <div class="" style="padding-top: 20px;">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <DataTable v-model:filters="filters" :value="dataWawancara" ref="dt" tableStyle="min-width: 50rem"
                       paginator :rows="10"
                       :rowsPerPageOptions="[5, 10, 20, 50]"
                       :first="0"
                       :loading="loading"
            >
              <template #empty> Data tidak ada. </template>
              <template #loading> Mengambil data. Mohon tunggu. </template>
              <Column field="no_formulir" header="Inv Id" sortable></Column>
              <Column field="biaya_konfirmasi" header="Tanda konfirmasi" sortable></Column>
              <Column field="nama_anak" header="Nama Anak" filterMatchMode="startsWith" sortable>
              </Column>
              <Column field="nama_ortu" header="Nama Ortu" sortable style="width: 25%"></Column>
              <Column field="tanggal_wawancara" header="Tanggal Wawancara" sortable style="width: 25%"></Column>
              <Column field="rekomendasi" header="Rekomendasi" sortable style="width: 25%"></Column>
              <Column>
                <template #body="slotProps">
                  <a href="#" @click="toggleGrid(slotProps.data)" class="fa-solid fa-eye" v-if="slotProps.data.sudahbayarkonfirmasi"></a>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PageUpdateHasilTesKognitif :data="selectedFormulir" v-if="!showgrid"
                              @change-view="toogleviewshowgrid"></PageUpdateHasilTesKognitif>
</template>

<script>
import {FilterMatchMode} from "@primevue/core/api";
import DashboardServices from "@/services/dashboard.services";
import PageUpdateHasilTesKognitif from "@/components/viewadmin/jadwaltestkognitif/PageUpdateHasilTesKognitif";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import BreadCrumb from "@/components/BreadCrumb";

export default {
  name: "PageHasilTesKognitif",
  components: {PageUpdateHasilTesKognitif,BreadCrumb,DataTable,Column},
  data:()=>({
    loading: false,
    lazyParams: {},
    showgrid: true,
    response:'',
    message:'',
    success: false,
    dataWawancara:[],
    selectedFormulir:[],
    totalRecords: 4,
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      'no_formulir': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'nama_anak': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'nama_ortu': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'jadwal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'tanggal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
    },
  }),
  methods:{
    toogleviewshowgrid(){
      this.showgrid = true;
    },
    toggleGrid(data){
      this.showgrid = !this.showgrid;
      this.selectedFormulir = data;
    },
    getDataHasilTesKognitif(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataWawancaraKognitif';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataWawancara = this.response.data.kebutuhankhusus;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },
  mounted() {
    this.lazyParams = {
      first: this.$refs.dt.first,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    this.getDataHasilTesKognitif();
  }
}
</script>

<style scoped>

</style>